import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDripsRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m10 8.3 2.2-4.7a.6.6 0 0 1 1.2 0l2.3 4.7a3.1 3.1 0 0 1-2.8 4.5h-.2A3.1 3.1 0 0 1 10 8.3M5 19.5l2.3-4.7a.6.6 0 0 1 1.2 0l2.3 4.7A3.1 3.1 0 0 1 8 24h-.2a3.1 3.1 0 0 1-2.8-4.5m15.7-8.3q.4 0 .6.3l.7 1.2.1.1 4.1 6.7a6 6 0 0 1-5.2 9.3h-.6a6.1 6.1 0 0 1-5.2-9.3l4-6.7h.1l.8-1.3q.2-.3.6-.3m-3.5 9.6a3.7 3.7 0 0 0 3.2 5.6h.6a3.7 3.7 0 0 0 3.2-5.6L20.8 15z" })
});
export default SvgDripsRegularIcon;
